/// <reference path="../../../teva/selectbox/selectbox.ts" />
/// <reference path="../../../teva/dropdown/dropdown.ts" />
/// <reference path="../../../teva/infinitescroll/infinitescroll.ts" />
/// <reference path="../../../teva/datepicker/datepicker.ts" />
/// <reference path="../../../teva/navigation/navigation.ts" />
/// <reference path="../../common/modals/modals.ts" />
/// <reference path="../../common/navigation/navigation.ts" />
/// <reference path="../../common/tableshortcuts/tableshortcuts.ts" />
/// <reference path="../main/main.ts" />
/// <reference path="../propertypicker/propertypicker.ts" />

namespace OfficeGuy.CRM {
    export class EntitiesList {
        private static ViewsApplicationActive: boolean;

        static Load($Form, AllowQuickEdit: boolean, ViewsApplicationActive: boolean): void {
            var IsPivot = $(".pivot-definition", $Form).length > 0;
            EntitiesList.ViewsApplicationActive = ViewsApplicationActive;
            if (Teva.Storage.LocalStorage_Get("ShowAll") == "1")
                $(".entities-table").addClass("entities-table-showall");

            $(".crmentitiesfield", $Form).each(function () {
                var $Element = $(this);
                if ($Element.data("valuetype") === undefined)
                    return;
                if (!IsPivot)
                    $Element.css("position", "relative");

                var FieldIndex = $Element.data("fieldindex");

                var $Link = $("a:first", $Element);
                $Link
                    .data("FieldIndex", FieldIndex)
                    .data("Element", $Element);
            });
            $(".entities-table tbody", $Form).on("click.entities-checkbox", "input.entities-checkbox", function () {
                EntitiesList.SelectedEntities_Selected($Form, $(this).prop("checked"));
                return true;
            });
            EntitiesList.InitTableRowClick(null);
            if (AllowQuickEdit)
                EntitiesList.InitTableQuickEdit();

            OfficeGuy.TableShortcuts.Init($(".entities-table-edit tbody", $Form));
            
            Teva.SelectBox.Enable($(".entities-table-summaryrow select", $Form), {
                AllowClear: false,
                AllowSearch: false,
                SupportHTML: true,
                OnChange: function () {
                    OfficeGuy.Forms.SubmitForm($Form);
                }
            });
            $(window).off("resize.entities-list").on("resize.entities-list", function () {
                var $Table = $(".entities-table:first");
                if ($Table.length == 0) {
                    $(window).off("resize.entities-list")
                    return;
                }
                var Table = $Table[0];
                /*if (Table.hasClass("entities-table-showall")) {
                    $(".entities-table-showall-toggle").hide();
                    return;
                }*/

                var $Columns = $Table.find("> thead > tr:first > th");
                for (var i = 0; i < $Columns.length; i++) {
                    var $Column = $($Columns[i]);
                    if (!$Column.data("crm-width"))
                        $Column.data("crm-width", $Column.outerWidth());
                    else
                        $Column.data("crm-width", Math.max($Column.data("crm-width"), $Column.outerWidth()));
                }
                var ShowMobileColumns = $Columns.filter(".crm-entities-showmobile").length > 0;

                var RemainingWidth = window.innerWidth - ($(".og-sidebar").css("position") == "fixed" ? $(".og-sidebar").outerWidth() : 0);
                RemainingWidth -= $($Columns[$Columns.length - 1]).data("crm-width") + 30;
                for (var i = 1; i < 10; i++) {
                    Table
                        .removeClass("entities-table-hidecolumn-" + i)
                        .removeClass("entities-table-primarycolumn-" + i);
                }
                if (window.innerWidth > 1000) {
                    Table.removeClass("entities-table-hidecolumn-10");
                    $(".entities-table-showall-toggle").hide();
                    return;
                }

                var PrimaryColumn = -1;
                var HasHiddenColumns = false;
                var VisibleColumns = 0;
                if (ShowMobileColumns) {
                    for (var i = 0; i < $Columns.length && i < 10; i++) {
                        if (!$($Columns[i]).hasClass("crm-entities-showmobile"))
                            continue;

                        RemainingWidth -= $($Columns[i]).data("crm-width");
                        if (VisibleColumns >= 2 && RemainingWidth < 0) {
                            Table.addClass("entities-table-hidecolumn-" + (i + 1));
                            HasHiddenColumns = true;
                        }
                        else {
                            VisibleColumns++;
                            if (PrimaryColumn == -1)
                                PrimaryColumn = i;
                        }
                    }

                    for (var i = 0; i < $Columns.length && i < 10; i++) {
                        if ($($Columns[i]).hasClass("crm-entities-showmobile"))
                            continue;

                        RemainingWidth -= $($Columns[i]).data("crm-width");
                        if (RemainingWidth < 0) {
                            Table.addClass("entities-table-hidecolumn-" + (i + 1));
                            HasHiddenColumns = true;
                        }
                        else if (PrimaryColumn == -1)
                            PrimaryColumn = i;
                    }
                }
                else {
                    for (var i = 0; i < $Columns.length && i < 10; i++) {
                        RemainingWidth -= $($Columns[i]).data("crm-width");
                        if (VisibleColumns >= 2 && RemainingWidth < 0) {
                            Table.addClass("entities-table-hidecolumn-" + (i + 1));
                            HasHiddenColumns = true;
                        }
                        else {
                            VisibleColumns++;
                            if (PrimaryColumn == -1)
                                PrimaryColumn = i;
                        }
                    }
                }

                $Table.toggleClass("entities-table-hidecolumn-10", RemainingWidth < 0);
                $(".entities-table-showall-toggle").toggle(HasHiddenColumns);

                if (Common.IsBrowserLowResolution())
                    Table.addClass("entities-table-primarycolumn-" + (PrimaryColumn + 1));
            }).trigger("resize.entities-list");

            if (Common.IsBrowserLowResolution())
                EntitiesList.HideFiltersBar();
        }

        static ToggleShowAll() {
            var Switch = !$(".entities-table").hasClass("entities-table-showall");
            $(".entities-table").toggleClass("entities-table-showall", Switch);
            Teva.Storage.LocalStorage_Set("ShowAll", Switch ? "1" : "0");

            $(window).trigger("resize.entities-list");
            return false;
        }

        static InitTableRowClick(Container) {
            $(".entities-table:not(.entities-table-edit) tbody", Container)
                .off("click.entities")
                .on("click.entities", "tr[data-entityid]", function (Event) {
                    if ($(Event.target).closest("a, input, textarea, button, .crm-entities-entity-checkbox").length != 0)
                        return true;

                    var URL = "/f" + $(this).data("schemaid") + "/c" + $(this).data("entityid") + "/";
                    if (Teva.Navigation.IsNewWindowEvent(Event))
                        window.open(URL);
                    else
                        Navigation.Redirect(URL);
                    return false;
                });
        }

        static InitTableQuickEdit() {
            if (Common.IsBrowserLowResolution())
                return;

            var $EditButton = $(".entities-table-quickedit");
            if ($EditButton.length == 0) {
                $EditButton = $(document.createElement('div')
                    .addClass("entities-table-quickedit")
                    .setText(Resources.GetString("CRM", "Edit")));
            }
            else
                $EditButton.off("click");

            var $EditButtonCell, PropertyID;
            $(".entities-table:not(.entities-table-edit) tbody")
                .on("mouseenter.entities", "td", function () {
                    var CellIndex = $(this).index();
                    if ($(this).hasClass("crm-entities-entity-name"))
                        PropertyID = 0;
                    else {
                        var $Header = $($(this).closest("table").find("thead tr.entities-table-fields th")[CellIndex]);
                        if ($Header.attr("data-preventquickedit") == "1" || $Header.find("input[name$=Path]").length > 1)
                            PropertyID = null;
                        else {
                            PropertyID = $Header.find("input[name$=Path]").val();
                            var ReadOnly = $Header.find("input[name$=ReadOnly]").val() == "True";
                            if (ReadOnly || PropertyID == null || PropertyID === undefined)
                                PropertyID = null;
                            else {
                                PropertyID = PropertyID.split(',');
                                if (PropertyID.length > 1 || PropertyID[0][0] == '-')
                                    PropertyID = null;
                            }
                        }
                    }
                    if (PropertyID == null)
                        $EditButtonCell = null;
                    else {
                        $EditButtonCell = $(this);
                        $EditButton
                            .appendTo($EditButtonCell)
                            .show();
                    }
                })
                .on("mouseleave.entities", "td", function () {
                    $EditButton.hide();
                    $(document.body).append($EditButton);
                });

            $EditButton.on("click", function (Event) {
                if ($EditButtonCell == null)
                    return true;

                var $Row = $EditButtonCell.closest("tr");
                var URL;
                if (PropertyID == 0)
                    URL = "/f" + $Row.data("schemaid") + "/c" + $Row.data("entityid") + "/edit/";
                else
                    URL = "/f" + $Row.data("schemaid") + "/c" + $Row.data("entityid") + "/p" + PropertyID + "/";
                if (Teva.Navigation.IsNewWindowEvent(Event))
                    window.open(URL);
                else if (PropertyID == 0)
                    Navigation.Redirect(URL);
                else {
                    var $Modal = Modals.ShowHTMLGetDialog({
                        URL: URL,
                        FullURL: URL,
                        ReplaceModal: true,
                        ConvertToAjax: true,
                        ConvertToAjax_PreRenderEvent: function (ResultData) {
                            if (typeof (ResultData) != "string" && ResultData.CustomData != null && ResultData.CustomData.HTML != null) {
                                if (ResultData.Notifications != null) {
                                    setTimeout(function () {
                                        Notifications.Show(ResultData.Notifications);
                                    }, 200);
                                }
                                var DisplayField = $EditButtonCell.find(".sumit-renderedfield:first");
                                if (DisplayField.length == 0) {
                                    $EditButtonCell.empty();
                                    DisplayField = $
                                        (document.createElement('div')
                                            .addClass("sumit-renderedfield"))
                                        .appendTo($EditButtonCell);
                                }
                                if (ResultData.CustomData.HTML == "")
                                    DisplayField.empty();
                                else
                                    DisplayField.html($(ResultData.CustomData.HTML).html());
                                Modals.Hide($Modal);
                                return true;
                            }
                            return false;
                        }
                    });
                }
                Event.stopPropagation();
                return false;
            });
        }

        static CreateEntitiesMenu($Form, IsSearchField, ValueType, MultipleValues, FieldIndex, EnableValueFilters) {
            var $Menu = $(document.createElement('div')
                .addClass("og-crm-entitiesmenu", "teva-dropdown-menu", "teva-dropdown-menu-single"));

            var IsPivot = $(".pivot-definition").length > 0;
            var ShowSeparator = false;
            if (!IsPivot && !IsSearchField) {
                var SortIndex = $("input[name='View.Fields[" + FieldIndex + "].SortIndex']", $Form).val();
                var SortDescending = $("input[name='View.Fields[" + FieldIndex + "].SortDescending']", $Form).val();

                ShowSeparator = true;
                $Menu.append($(document.createElement('a').addClass("teva-dropdown-menu-item", "teva-dropdown-menu-item-withicon"))
                    .append('<span class="menu-icon icon-sort-name-up"></span>' + OfficeGuy.Resources.GetString("CRM_EntitiesList", "SortAscending"))
                    .css("font-weight", SortIndex != "" && SortDescending != "True" ? "bold" : "")
                    .attr("href", "#")
                    .on("click", function () {
                        EntitiesList.EntitiesMenu_Sort($Form, "False");
                        return false;
                    })
                );
                $Menu.append($(document.createElement('a').addClass("teva-dropdown-menu-item", "teva-dropdown-menu-item-withicon"))
                    .append('<span class="menu-icon icon-sort-name-down"></span>' + OfficeGuy.Resources.GetString("CRM_EntitiesList", "SortDescending"))
                    .css("font-weight", SortIndex != "" && SortDescending == "True" ? "bold" : "")
                    .attr("href", "#")
                    .on("click", function () {
                        EntitiesList.EntitiesMenu_Sort($Form, "True");
                        return false;
                    })
                );
            }

            if (EntitiesList.IsSearchableField(ValueType)) {
                var SerializedFilters = $("input[name='View.Fields[" + FieldIndex + "].SerializedFilters']", $Form).val();
                var HasFilters = SerializedFilters && SerializedFilters != 'null';
                if (!IsPivot) {
                    ShowSeparator = true;
                    $Menu.append($(document.createElement('a').addClass("teva-dropdown-menu-item", "teva-dropdown-menu-item-withicon"))
                        .append('<span class="menu-icon icon-filter"></span>' + OfficeGuy.Resources.GetString("CRM_EntitiesList", "Filters"))
                        .css("font-weight", HasFilters ? "bold" : "")
                        .attr("href", "#")
                        .on("click", function () {
                            EntitiesList.ShowFiltersByFieldIndex(OfficeGuy.CRM.Main.$EntitiesList_MenuElement.data("fieldindex"));
                            return false;
                        })
                    );
                }
                if (HasFilters) {
                    ShowSeparator = true;
                    $Menu.append($(document.createElement('a').addClass("teva-dropdown-menu-item", "teva-dropdown-menu-item-withicon"))
                        .append('<span class="menu-icon icon-block"></span>' + OfficeGuy.Resources.GetString("CRM_EntitiesList", "ClearFilters"))
                        .attr("href", "#")
                        .on("click", function () {
                            EntitiesList.EntitiesMenu_ClearFilters()
                            return false;
                        })
                    );
                }
            }

            if (EntitiesList.ViewsApplicationActive) {
                if (ShowSeparator)
                    $Menu.append(document.createElement('div').addClass("teva-dropdown-menu-separator"));

                if (!IsPivot) {
                    $Menu.append($(document.createElement('a').addClass("teva-dropdown-menu-item", "teva-dropdown-menu-item-withicon"))
                        .append('<span class="menu-icon icon-sumit-edit"></span>' + OfficeGuy.Resources.GetString("CRM_EntitiesList", "RenameColumn"))
                        .attr("href", "#")
                        .on("click", EntitiesList.EntitiesMenu_RenameColumn)
                    );
                }
                $Menu.append($(document.createElement('a').addClass("teva-dropdown-menu-item", "teva-dropdown-menu-item-withicon"))
                    .append('<span class="menu-icon icon-sumit-close"></span>' + OfficeGuy.Resources.GetString("CRM_EntitiesList", "HideColumn"))
                    .attr("href", "#")
                    .on("click", EntitiesList.EntitiesMenu_HideColumn)
                );
            }
            if (EntitiesList.ViewsApplicationActive && !IsPivot) {
                var $Header = $("input[name='View.Fields[" + FieldIndex + "].Path']").closest("th");
                var PropertyID;
                if ($Header.attr("data-preventcolumnupdate") == "1" || $Header.find("input[name$=Path]").length > 1)
                    PropertyID = null;
                else {
                    PropertyID = $Header.find("input[name$=Path]").val();
                    var ReadOnly = $Header.find("input[name$=ReadOnly]").val() == "True";
                    if (ReadOnly || PropertyID == null || PropertyID === undefined)
                        PropertyID = null;
                    else {
                        PropertyID = PropertyID.split(',');
                        if (PropertyID.length > 1 || PropertyID[0][0] == '-')
                            PropertyID = null;
                    }
                }

                if (PropertyID != null) {
                    $Menu.append($(document.createElement('a').addClass("teva-dropdown-menu-item", "teva-dropdown-menu-item-withicon"))
                        .append('<span class="menu-icon icon-sumit-wand"></span>' + OfficeGuy.Resources.GetString("CRM_EntitiesList", "UpdateColumn"))
                        .attr("href", "#")
                        .on("click", function () {
                            OfficeGuy.CRM.EntitiesList.ColumnUpdate($("#SchemaID").val(), $("#View_ID").val(), PropertyID);
                            return false;
                        })
                    );
                }
            }

            if (!IsPivot && !IsSearchField) {
                $Menu.append($(document.createElement('div').addClass("teva-dropdown-menu-separator")));

                if (MultipleValues && (ValueType == "Int64" || ValueType == "Decimal" || ValueType == "Date" || ValueType == "DateTime" || ValueType == "Time" || ValueType == "Month")) {
                    $Menu.append($(document.createElement('a').addClass("teva-dropdown-menu-item", "teva-dropdown-menu-item-withicon"))
                        .css("font-weight", $("input[name='View.Fields[" + FieldIndex + "].GroupType']").val() != '' ? "bold" : "")
                        .append('<span class="menu-icon icon-summary"></span>' + OfficeGuy.Resources.GetString("CRM_EntitiesList", "CellSummary"))
                        .attr("href", "#")
                        .on("click", function () {
                            EntitiesList.EntitiesMenu_CellSummary($Form);
                            return false;
                        })
                    );
                }

                if (EntitiesList.ViewsApplicationActive && EnableValueFilters) {
                    $Menu.append($(document.createElement('a').addClass("teva-dropdown-menu-item", "teva-dropdown-menu-item-withicon"))
                        .append('<span class="menu-icon icon-flow-merge icon-rotate-180"></span>' + OfficeGuy.Resources.GetString("CRM_EntitiesList", "DependentFiltered"))
                        .attr("href", "#")
                        .on("click", function () {
                            EntitiesList.EntitiesMenu_ValueFilters();
                            return false;
                        })
                    );
                }

                $Menu.append($(document.createElement('a').addClass("teva-dropdown-menu-item", "teva-dropdown-menu-item-withicon"))
                    .css("font-weight", $("input[name='View.Fields[" + FieldIndex + "].SummaryGroupType']").val() != '' ? "bold" : "")
                    .append('<span class="menu-icon icon-summary"></span>' + OfficeGuy.Resources.GetString("CRM_EntitiesList", "ShowSummaryLine"))
                    .attr("href", "#")
                    .on("click", function () {
                        EntitiesList.EntitiesMenu_ToggleSummaryRow($Form);
                        return false;
                    })
                );
            }

            if (IsPivot && !IsSearchField && (ValueType == "Date" || ValueType == "DateTime" || ValueType == "Month")) {
                var NormalizationMode = $("input[name='View.Fields[" + FieldIndex + "].NormalizationMode']", $Form).val();
                if (ValueType == "DateTime") {
                    $Menu.append($(document.createElement('a').addClass("teva-dropdown-menu-item", "teva-dropdown-menu-item-withicon"))
                        .append('<span class="menu-icon icon-summary"></span>' + OfficeGuy.Resources.GetString("CRM", "NormalizeByDay"))
                        .css("font-weight", NormalizationMode == "Day" ? "bold" : "")
                        .attr("href", "#")
                        .on("click", function () {
                            EntitiesList.EntitiesMenu_PivotNormalization('Day')
                            return false;
                        }));
                }
                if (ValueType == "DateTime" || ValueType == "Date") {
                    $Menu.append($(document.createElement('a').addClass("teva-dropdown-menu-item", "teva-dropdown-menu-item-withicon"))
                        .append('<span class="menu-icon icon-summary"></span>' + OfficeGuy.Resources.GetString("CRM", "NormalizeByMonth"))
                        .css("font-weight", NormalizationMode == "Month" ? "bold" : "")
                        .attr("href", "#")
                        .on("click", function () {
                            EntitiesList.EntitiesMenu_PivotNormalization('Month')
                            return false;
                        }));
                }
                $Menu.append($(document.createElement('a').addClass("teva-dropdown-menu-item", "teva-dropdown-menu-item-withicon"))
                    .append('<span class="menu-icon icon-summary"></span>' + OfficeGuy.Resources.GetString("CRM", "NormalizeByQuarter"))
                    .css("font-weight", NormalizationMode == "Quarter" ? "bold" : "")
                    .attr("href", "#")
                    .on("click", function () {
                        EntitiesList.EntitiesMenu_PivotNormalization('Quarter')
                        return false;
                    }));
                $Menu.append($(document.createElement('a').addClass("teva-dropdown-menu-item", "teva-dropdown-menu-item-withicon"))
                    .append('<span class="menu-icon icon-summary"></span>' + OfficeGuy.Resources.GetString("CRM", "NormalizeByHalfYear"))
                    .css("font-weight", NormalizationMode == "HalfYear" ? "bold" : "")
                    .attr("href", "#")
                    .on("click", function () {
                        EntitiesList.EntitiesMenu_PivotNormalization('HalfYear')
                        return false;
                    }));
                $Menu.append($(document.createElement('a').addClass("teva-dropdown-menu-item", "teva-dropdown-menu-item-withicon"))
                    .append('<span class="menu-icon icon-summary"></span>' + OfficeGuy.Resources.GetString("CRM", "NormalizeByYear"))
                    .css("font-weight", NormalizationMode == "Year" ? "bold" : "")
                    .attr("href", "#")
                    .on("click", function () {
                        EntitiesList.EntitiesMenu_PivotNormalization('Year')
                        return false;
                    }));
            }

            $Menu.appendTo(document.body);
        }

        static RefreshMenu($Link, EnableValueFilters) {
            var $Form = $Link.closest("form.crmform");
            var $Element = $Link.data("Element");

            var FieldIndex = $Link.data("FieldIndex");
            $(".og-crm-entitiesmenu").remove();
            var IsSearchField = $Link.closest(".entities-search").length > 0;
            EntitiesList.CreateEntitiesMenu($Form, IsSearchField, $Element.data("valuetype"), $Element.data("multiplevalues") == "1", FieldIndex, EnableValueFilters);

            OfficeGuy.CRM.Main.$EntitiesList_MenuElement = $Element;
            return false;
        }

        static InitKeyboardShortcuts(SchemaID, AllowCreate, AllowEdit) {
            var $Document = $(document);
            if (AllowCreate == 1) {
                $Document.on("keyup.altc", null, "alt+c", function (Event) {
                    // Create
                    Navigation.Redirect("/f" + SchemaID + "/new/");
                    Event.preventDefault();
                    Event.stopPropagation();
                    return false;
                });
            }
            if (AllowEdit == 1) {
                $Document.on("keyup.altw", null, "alt+w", function (Event) {
                    // Edit
                    $('input[name=Edit]').val("true").closest('form').trigger("submit");
                    Event.preventDefault();
                    Event.stopPropagation();
                    return false;
                });
            }
        }

        static InitScroll($Form) {
            Teva.InfiniteScroll.Enable({
                ContainerSelector: $Form,
                ResultsContainerSelector: ".entities-table tbody",
                ItemSelector: "tr",
                PaginationSelector: ".entities-table tfoot",
                NextSelector: ".entities-table tfoot a",
                OnRenderComplete: function () {
                    var IsChecked = $(".crmform thead > tr > th input.entities-checkbox").prop("checked");
                    if (IsChecked)
                        $(".crmform .entities-table > tbody > tr > td input.entities-checkbox").prop("checked", true);
                    Common.InitEditors($Form);
                },
                CustomGetContent: function ($NextPageLink, Callback) {
                    var $Form = $(".entities-table").closest("form");
                    $.ajax({
                        method: "POST",
                        url: $NextPageLink.attr("href"),
                        data: $Form.find("input, select, textarea").not("[name^='Entity[']").serialize(),
                        success: Callback,
                        dataType: "html"
                    });
                }
            });
        }

        static ShowFiltersBar() {
            $(".entities-search-field, .entities-search-hide").show();
            $(".entities-search-show").hide();
            return false;
        }

        static HideFiltersBar() {
            $(".entities-search-field, .entities-search-hide").hide();
            $(".entities-search-show").show();
            return false;
        }

        static ToggleSelectedMenu(Show) {
            var $Selected = $(".entitiesdropdown-selected");
            if (Show) {
                if (!$Selected.parent().hasClass("og-navigation-bar-inner"))
                    $(".og-navigation-bar-inner").append($Selected);
                $(".og-navigation-bar-buttons:not(.og-navigation-bar-buttons-selected)").clearQueue().hide();
                $Selected.clearQueue().fadeIn();
            }
            else {
                $Selected.clearQueue().hide();
                $(".og-navigation-bar-buttons:not(.og-navigation-bar-buttons-selected)").clearQueue().fadeIn();
            }
        }

        static SelectedEntities_ToggleSelectAll(Link): boolean {
            var $Form = $(Link).closest("form.crmform");
            var IsChecked = $("thead > tr > th input.entities-checkbox", $Form).prop("checked");

            $(".entities-table > tbody > tr > td input.entities-checkbox", $Form).prop("checked", IsChecked);
            $("thead > tr > th input.entities-checkbox", $Form).parent().attr("title", IsChecked ? OfficeGuy.Resources.GetString("CRM", "UnselectAll") : OfficeGuy.Resources.GetString("CRM", "SelectAll"));
            Common.Tooltip_Hide();
            EntitiesList.ToggleSelectedMenu(IsChecked);
            return false;
        }
        static SelectedEntities_Selected($Form, IsChecked: boolean): void {
            var $Selected = $(".entitiesdropdown-selected");
            if (IsChecked) {
                var AllChecked = $(".entities-table > tbody > tr > td:nth-child(1) input.entities-checkbox:not(:checked)", $Form).length == 0;
                if (AllChecked) {
                    $("thead > tr > th input.entities-checkbox", $Form)
                        .prop("checked", true)
                        .parent()
                        .attr("title", OfficeGuy.Resources.GetString("CRM", "UnselectAll"));
                }
                if (!$Selected.parent().hasClass("og-navigation-bar-inner"))
                    $(".og-navigation-bar-inner").append($Selected);
                $(".og-navigation-bar-buttons:not(.og-navigation-bar-buttons-selected)").clearQueue().hide();
                $Selected.clearQueue().fadeIn();
            }
            else {
                var NoneChecked = $(".entities-table > tbody > tr > td:nth-child(1) input.entities-checkbox:checked", $Form).length == 0;
                $("thead > tr > th input.entities-checkbox", $Form)
                    .prop("checked", false)
                    .parent()
                    .attr("title", OfficeGuy.Resources.GetString("CRM", "SelectAll"));
                if (NoneChecked) {
                    $Selected.clearQueue().hide();
                    $(".og-navigation-bar-buttons:not(.og-navigation-bar-buttons-selected)").clearQueue().fadeIn();
                }
            }
        }
        static SelectedEntities_Command(Link, Name, ConfirmTitle?: any, ConfirmMessage?: any, ConfirmButton?: any): boolean {
            var $Form = $(Link).closest("form.crmform");
            if ($Form.length == 0)
                $Form = $("form.crmform");
            var Checked = $(".entities-table tbody input.entities-checkbox:checked").length;
            if (Checked != 0) {
                if (ConfirmMessage === undefined || ConfirmMessage == null) {
                    $("input[name=SelectedCommand]", $Form).val(Name);
                    $("input[name=SelectedEntities]", $Form).val(EntitiesList.SelectedEntities_GetSelected());
                    OfficeGuy.Forms.SubmitForm($Form);
                }
                else {
                    OfficeGuy.Modals.ShowConfirmDialog({
                        Title: ConfirmTitle,
                        Message: ConfirmMessage.replace("{Count}", Checked),
                        ConfirmText: ConfirmButton,
                        ConfirmEvent: function () {
                            EntitiesList.SelectedEntities_Command(Link, Name);
                        }
                    });
                }
            }
            else
                OfficeGuy.Modals.ShowMessageDialog(OfficeGuy.Resources.GetString("CRM", "SelectCard"), OfficeGuy.Resources.GetString("CRM", "NoCardsSelected"));
            return false;
        }
        static SelectedEntities_GetSelected(): string {
            var ToReturn = "";
            var $Checked = $(".entities-table tbody input.entities-checkbox:checked");
            for (var i = 0; i < $Checked.length; i++) {
                if (ToReturn.length != 0)
                    ToReturn += ",";
                ToReturn += $($Checked[i]).closest("tr").data("entityid");
            }
            return ToReturn;
        }

        static EntitiesMenu_HideColumn(): boolean {
            $(".og-crm-entitiesmenu").hide();
            var $Element = OfficeGuy.CRM.Main.$EntitiesList_MenuElement;
            var FieldIndex = $Element.data("fieldindex");
            EntitiesList.RemoveFieldByFieldIndex(FieldIndex);
            return false;
        }
        static EntitiesMenu_RenameColumn(): boolean {
            $(".og-crm-entitiesmenu").hide();
            var $Element = OfficeGuy.CRM.Main.$EntitiesList_MenuElement;
            var $Modal = OfficeGuy.Modals.ShowInputDialog({
                Title: OfficeGuy.Resources.GetString("CRM", "RenameColumn"),
                ConfirmText: OfficeGuy.Resources.GetString("CRM", "Save"),
                ConfirmEvent: function (NewName) {
                    $("input[name$='.Name']:first", $Element).val(NewName);
                    if (NewName.length > 15) {
                        $("a:first span:first", $Element).text(OfficeGuy.Common.ShortWithDots(NewName, 15));
                        $("a:first", $Element).addClass("using-tooltip").attr("title", NewName);
                    }
                    else {
                        $("a:first span:first", $Element).text(NewName);
                        $("a:first", $Element).removeClass("using-tooltip").removeAttr("title");
                    }

                    OfficeGuy.Modals.Hide($Modal);
                }
            });
            return false;
        }
        static EntitiesMenu_ClearFilters(): boolean {
            $(".og-crm-entitiesmenu").hide();
            EntitiesList.UpdateFieldFilters(OfficeGuy.CRM.Main.$EntitiesList_MenuElement.data("fieldindex"), null);
            return false;
        }
        static ClearFiltersByFieldIndex(FieldIndex) {
            EntitiesList.UpdateFieldFilters(FieldIndex, null);
            window.event.stopPropagation();
            window.event.stopImmediatePropagation();
            return false;
        }
        static RemoveFieldByFieldIndex(FieldIndex) {
            Modals.HideAll(true, function () {
                var $Element = $(".crmentitiesfield[data-fieldindex=" + FieldIndex + "]");
                OfficeGuy.Forms.NestedForm_Remove(null, "View.Fields", FieldIndex);
                $Element.closest("form").trigger("submit");
                window.event.stopPropagation();
                window.event.stopImmediatePropagation();
            });
            return false;
        }

        static UpdateFieldFilters(FieldIndex, SerializedFilters) {
            Modals.HideAll(true, function () {
                var $Field = $("input[name='View.Fields[" + FieldIndex + "].SerializedFilters']").val(SerializedFilters);
                OfficeGuy.Forms.SubmitForm($Field.closest('form'));
            });
        }

        static ShowFiltersByFieldIndex(FieldIndex): boolean {
            $(".og-crm-entitiesmenu").hide();
            var $Element = $(".crmentitiesfield[data-fieldindex=" + FieldIndex + "]");

            EntitiesList.ShowFilters($Element.closest("form").serialize(), FieldIndex);
            return false;
        }
        static EntitiesMenu_CellSummary($Form): void {
            $(".og-crm-entitiesmenu").hide();
            var $Element = OfficeGuy.CRM.Main.$EntitiesList_MenuElement;
            var FieldIndex = $Element.data("fieldindex");

            var $Container = $(document.createElement('div')
                .addClass("filter-cellsummary"))
                .addClass("teva-dropdown-menu")
                .appendTo($Element);

            var ValueType = $Element.data("valuetype");

            EntitiesList.EntitiesMenu_CellSummary_CreateButton($Form, $Container, FieldIndex, OfficeGuy.Resources.GetString("CRM", "CellSummary_None"), "");
            EntitiesList.EntitiesMenu_CellSummary_CreateButton($Form, $Container, FieldIndex, OfficeGuy.Resources.GetString("CRM", "CellSummary_Count"), "Count");
            if (ValueType == "Int64" || ValueType == "Decimal") {
                EntitiesList.EntitiesMenu_CellSummary_CreateButton($Form, $Container, FieldIndex, OfficeGuy.Resources.GetString("CRM", "CellSummary_Sum"), "Sum");
                EntitiesList.EntitiesMenu_CellSummary_CreateButton($Form, $Container, FieldIndex, OfficeGuy.Resources.GetString("CRM", "CellSummary_Average"), "Average");
            }
            //if (Field.Property.ValueType is Teva.Common.DynamicDB.Typed.Schema.PropertyValueType.Int64 or Teva.Common.DynamicDB.Typed.Schema.PropertyValueType.Decimal or Teva.Common.DynamicDB.Typed.Schema.PropertyValueType.Date or Teva.Common.DynamicDB.Typed.Schema.PropertyValueType.DateTime or Teva.Common.DynamicDB.Typed.Schema.PropertyValueType.Month or Teva.Common.DynamicDB.Typed.Schema.PropertyValueType.Time)

            EntitiesList.EntitiesMenu_CellSummary_CreateButton($Form, $Container, FieldIndex, OfficeGuy.Resources.GetString("CRM", "CellSummary_Minimum"), "Minimum");
            EntitiesList.EntitiesMenu_CellSummary_CreateButton($Form, $Container, FieldIndex, OfficeGuy.Resources.GetString("CRM", "CellSummary_Maximum"), "Maximum");

            OfficeGuy.Common.ShowBelow($Container, $Element);
        }
        static EntitiesMenu_CellSummary_CreateButton($Form, $Container, FieldIndex, Text, Value): void {
            $Container.append($(document.createElement('a').addClass("teva-dropdown-menu-item"))
                .css("font-weight", $("input[name='View.Fields[" + FieldIndex + "].GroupType']", $Form).val() == Value ? "bold" : "")
                .text(Text)
                .attr("href", "#")
                .on("click", function () {
                    $("input[name='View.Fields[" + FieldIndex + "].GroupType']", $Form).val(Value);
                    Common.ShowBelow_Rollback($Container);
                    OfficeGuy.Forms.SubmitForm($Form);
                    return false;
                })
            );
        }

        static ClearAllFilters(Link) {
            var $Form = $(Link).closest("form.crmform");
            $("input[name$='.SerializedFilters']", $Form).val(null);
            OfficeGuy.Forms.SubmitForm($Form);
            return false;
        }

        static AutoAddRecords() {
            if ($(".entities-table-edit tbody tr").length == 0)
                $(".entities-table-add-record").click();
            $(".entities-table-edit").on("change.autoaddrecords", "tr input, tr textarea", function (Event) {
                var $Input = $(Event.target);
                var $Row = $Input.closest("tr");
                $Row.addClass("entities-table-row-unsaved");
                if ($Row.next().length == 0 && $Input.val() != null && (<string>$Input.val()).length > 0) {
                    setTimeout(function () {
                        $(".entities-table-add-record").click();
                    }, 10);
                    var $Version = $(this).closest("tr").find(".hiddenversion");
                    if ($Version.val() == "-1")
                        $Version.val("0");
                }
                return true;
            });
            $(".entities-table-edit").on("focusout", "tr", function (Event) {
                var $SelectedRow = $(Event.relatedTarget).closest("tr");
                var $PreviousRow = $(Event.currentTarget);
                if ($SelectedRow.length == 1 && $SelectedRow[0] == $PreviousRow[0])
                    return;
                if ($PreviousRow.hasClass("entities-table-row-unsaved"))
                    EntitiesList.AutoSaveRecord($PreviousRow);
            });
        }
        static SaveList() {

            if ($('.entities-table-row-saving').length > 0) {
                var AttemptsPending = 30;
                Common.Loading_Show();

                var Interval = setInterval(function () {
                    AttemptsPending--;
                    if ($('.entities-table-row-saving').length == 0) {
                        clearInterval(Interval);
                        OfficeGuy.Forms.SubmitForm();
                        Common.Loading_Hide();
                    }
                    if (AttemptsPending == 0) {
                        OfficeGuy.Forms.SubmitForm();
                        Common.Loading_Hide();
                    }
                }, 100);
            }
            else
                OfficeGuy.Forms.SubmitForm();
            return false;
        }
        static AutoSaveRecord($Row, Callback?, ErrorCallback?) {
            if ($Row.hasClass("entities-table-row-saving")) {
                $Row.addClass("entities-table-row-pendingresave")
                if (Callback)
                    Callback();
                return;
            }

            $Row.addClass("entities-table-row-saving");

            CRM.Main.UpdateCustomFields($Row);
            var $Fields = $Row.find("input, textarea, select")
                .add($(".entities-table-fields, .entities-search").find("input, textarea, select"))
                .add(".crmform_entities > input");
            var Data = $Fields.serialize();
            var Index = $Row.index();
            var $Field = $Fields.filter('[name^="RenderedFieldsRecords["]').first();
            if ($Field.length > 0) {
                Index = $Field.attr("name").substring('RenderedFieldsRecords['.length);
                Index = Index.substring(0, Index.indexOf(']'));
            }

            Data += "&RenderedFieldsRecords.Index=" + Index;

            Common.AjaxRequest({
                URL: "/crm/entitiesupdateentity/",
                Data: Data,
                ContentType: "application/x-www-form-urlencoded; charset=UTF-8",
                ProcessData: false,
                SuccessMethod: function (Response) {
                    $Row.find(".entities-table-buttons input[name$='.EntityID']").val(Response.EntityID);
                    $Row.find(".entities-table-buttons input[name$='.Version']").val(Response.EntityVersion);
                    $Row.removeClass("entities-table-row-saving entities-table-row-error");

                    if ($Row.hasClass("entities-table-row-pendingresave")) {
                        $Row.removeClass("entities-table-row-pendingresave")
                        EntitiesList.AutoSaveRecord($Row, Callback, ErrorCallback);
                    }
                    else {
                        $Row.removeClass("entities-table-row-unsaved");
                        if (Callback)
                            Callback();
                    }
                },
                ErrorMethod: function () {
                    $Row.removeClass("entities-table-row-saving").addClass("entities-table-row-error");

                    if ($Row.hasClass("entities-table-row-pendingresave")) {
                        $Row.removeClass("entities-table-row-pendingresave")
                        EntitiesList.AutoSaveRecord($Row, Callback, ErrorCallback);
                    }
                    else if (ErrorCallback)
                        ErrorCallback();
                },
                ShowLoading: false
            });
        }
        static CloneEntity($Link) {
            var $Row = $Link.closest("tr").clone();
            $Row.find("td:last input[name$=EntityID]").val("0");
            $("td.crm-entities-entity-name", $Row).empty();
            $(".teva-selectbox", $Row).remove();

            var PreviousNamePrefix, PreviousIDPrefix, NewNamePrefix, NewIDPrefix;
            NewNamePrefix = "RenderedFieldsRecords[" + $(".entities-table > tbody").children().length + "]";
            NewIDPrefix = "RenderedFieldsRecords_" + $(".entities-table > tbody").children().length + "_";

            $Link.closest("tbody").append($Row);

            $Row.find("input, select, textarea").each(function () {
                if ($(this).attr("name") && $(this).attr("name").indexOf("RenderedFieldsRecords[") == 0) {
                    if (PreviousNamePrefix == null)
                        PreviousNamePrefix = $(this).attr("name").substring(0, $(this).attr("name").indexOf(']') + 1);
                    $(this).attr("name", NewNamePrefix + $(this).attr("name").substring(PreviousNamePrefix.length));
                }
                if ($(this).attr("id") && $(this).attr("id").indexOf("RenderedFieldsRecords_") == 0) {
                    if (PreviousIDPrefix == null) {
                        PreviousIDPrefix = $(this).attr("id").substring(0, $(this).attr("id").indexOf('_', 'RenderedFieldsRecords_'.length + 1) + 1);
                    }
                    $(this).attr("id", NewIDPrefix + $(this).attr("id").substring(PreviousIDPrefix.length));
                }
            });

            OfficeGuy.Common.InitEditors($Row);
            return false;
        }
        static RemoveEntity(Link) {
            $(Link).closest("tr").remove();
            return false;
        }

        static PrintSelectedEntities(): boolean {
            var SelectedEntities = EntitiesList.SelectedEntities_GetSelected();
            if (SelectedEntities.length == 0)
                return true;
            window.open(Common.RootURL + "crm/printmultipleentities/?ids=" + SelectedEntities);
            return false;
        }

        static AddFieldToEntities(Element, RootSchemaID, PivotRow, PivotColumn, PivotValue, Visible) {
            PropertyPicker.ShowPropertyPicker(RootSchemaID, function (Path, Name, PathNames, ValueType) {
                Modals.HideAll(false, function () {
                    var Index = $("input[name^='View.Fields['][name$='].ID']", $Form).length;
                    var $Form = $(Element).closest("form");
                    var MinimumID = -1;
                    $("input[name^='View.Fields['][name$='].ID']", $Form).each(function () {
                        if (Number($(this).val()) <= MinimumID)
                            MinimumID = Number($(this).val()) - 1;
                    });
                    $Form.append($(document.createElement('input'))
                        .attr("type", "hidden")
                        .attr("Name", "View.Fields[" + Index + "].ID")
                        .val(MinimumID.toString()));
                    $Form.append($(document.createElement('input'))
                        .attr("type", "hidden")
                        .attr("Name", "View.Fields[" + Index + "].Index")
                        .val(Index.toString()));
                    $Form.append($(document.createElement('input'))
                        .attr("type", "hidden")
                        .attr("Name", "View.Fields[" + Index + "].Path")
                        .val(Path));
                    $Form.append($(document.createElement('input'))
                        .attr("type", "hidden")
                        .attr("Name", "View.Fields[" + Index + "].SearchField")
                        .val(Visible == false ? "true" : "false"));
                    if (!Visible && !EntitiesList.IsSearchableField(ValueType))
                        $Form.append($(document.createElement('input'))
                            .attr("type", "hidden")
                            .attr("Name", "View.Fields[" + Index + "].SearchFieldExists")
                            .val('true'));
                    if (PivotValue) {
                        if (ValueType == "Int64" || ValueType == "Decimal")
                            $Form.append($(document.createElement('input'))
                                .attr("type", "hidden")
                                .attr("Name", "View.Fields[" + Index + "].GroupType")
                                .val('0')); // Sum
                        else
                            $Form.append($(document.createElement('input'))
                                .attr("type", "hidden")
                                .attr("Name", "View.Fields[" + Index + "].GroupType")
                                .val('1')); // Count
                    }
                    else
                        $Form.append($(document.createElement('input'))
                            .attr("type", "hidden")
                            .attr("Name", "View.Fields[" + Index + "].GroupType")
                            .val(null));
                    if (PivotRow != null)
                        $Form.append($(document.createElement('input'))
                            .attr("type", "hidden")
                            .attr("Name", "View.Fields[" + Index + "].PivotRow")
                            .val(PivotRow));
                    if (PivotColumn != null)
                        $Form.append($(document.createElement('input'))
                            .attr("type", "hidden")
                            .attr("Name", "View.Fields[" + Index + "].PivotColumn")
                            .val(PivotColumn));
                    OfficeGuy.Forms.SubmitForm('form.crmform');
                });
            }, true, null, null, !Visible, true, PivotRow || PivotColumn || PivotColumn ? null : (Visible ? "הוספת שדה לתצוגה" : "הוספת פילטר"));
            return false;
        }

        static EntitiesMenu_Sort($Form, Descending): void {
            $(".og-crm-entitiesmenu", $Form).hide();
            var $Element = OfficeGuy.CRM.Main.$EntitiesList_MenuElement;
            var FieldIndex = $Element.data("fieldindex");

            var IsClear = $("input[name='View.Fields[" + FieldIndex + "].SortIndex']", $Form).val() == "0" && $("input[name='View.Fields[" + FieldIndex + "].SortDescending']", $Form).val() == Descending;
            $('input[name$=".SortIndex"]', $Form).val('');

            if (!IsClear) {
                $("input[name='View.Fields[" + FieldIndex + "].SortIndex']", $Form).val('0');
                $("input[name='View.Fields[" + FieldIndex + "].SortDescending']", $Form).val(Descending);
            }

            OfficeGuy.Forms.SubmitForm($Form);
        }

        static EntitiesMenu_ValueFilters(): boolean {
            var $Element = OfficeGuy.CRM.Main.$EntitiesList_MenuElement;
            var FieldIndex = $Element.data("fieldindex");

            $(".og-crm-entitiesmenu").hide();

            var SchemaID = $("#SchemaID").val();
            PropertyPicker.ShowPropertyPicker(SchemaID, function (Path, Name, PathNames) {
                var SerializedForm = $Element.parents("form").serialize();
                EntitiesList.ShowFilters(SerializedForm, FieldIndex, Path);
            });

            return false;
        }

        static IsSearchableField(ValueType) {
            return ValueType != "SchemaViewProperty"
                && ValueType != "SchemaProperty"
                && ValueType != "SchemaView"
                && ValueType != "RichText"
                && ValueType != "Hyperlink"
                && ValueType != "NavigationAddress";
        }
        static ShowFilters(SerializedForm, FieldIndex, ValueFieldPath?) {
            Common.AjaxRequest({
                URL: "/crm/entitiesfieldfilter/",
                Data: SerializedForm + "&fieldindex=" + FieldIndex + (ValueFieldPath == null ? "" : "&valuefieldpath=" + ValueFieldPath),
                ContentType: "application/x-www-form-urlencoded; charset=UTF-8",
                ProcessData: false,
                SuccessMethod: function (Response) {
                    OfficeGuy.Navigation.ShowLightboxHTML(Response, $(".crmentitiesfield[data-fieldindex=" + FieldIndex + "]"));
                }
            });
        }

        static EntitiesMenu_ToggleSummaryRow($Form): boolean {
            $(".og-crm-entitiesmenu").hide();
            var $Element = OfficeGuy.CRM.Main.$EntitiesList_MenuElement;
            var FieldIndex = $Element.data("fieldindex");
            var $SummaryGroupTypeElement = $("input[name='View.Fields[" + FieldIndex + "].SummaryGroupType'], select[name='View.Fields[" + FieldIndex + "].SummaryGroupType']", $Form);
            // Int32/Decimal should default to Sum?
            if ($SummaryGroupTypeElement.val() == "") {
                var ValueType = $Element.data("valuetype");
                if (ValueType == "Int64" || ValueType == "Decimal")
                    $SummaryGroupTypeElement.val("Sum");
                else
                    $SummaryGroupTypeElement.val("Count");
            }
            else
                $SummaryGroupTypeElement.val("");
            OfficeGuy.Forms.SubmitForm($Form);
            return false;
        }

        static EntitiesMenu_PivotNormalization(NormalizationMode): boolean {
            Modals.HideAll(true, function () {
                $(".og-crm-entitiesmenu").hide();
                var $Element = OfficeGuy.CRM.Main.$EntitiesList_MenuElement;
                var FieldIndex = $Element.data("fieldindex");
                var $FieldNormalizationElement = $("input[name='View.Fields[" + FieldIndex + "].NormalizationMode']");
                $FieldNormalizationElement.val($FieldNormalizationElement.val() == NormalizationMode ? "None" : NormalizationMode);
                OfficeGuy.Forms.SubmitForm($FieldNormalizationElement.closest('form'));
            });
            return false;
        }

        static CreateTemporaryView(Callback) {
            var Form = <any>$("form.crmform_entities");
            var Data;
            if (typeof (FormData) !== "undefined" && FormData)
                Data = new FormData(Form[0]);
            else
                Data = Form.serialize();

            Common.AjaxRequest({
                URL: "/crm/createtemporaryview/",
                Data: Data,
                ContentType: false,
                ProcessData: false,
                SuccessMethod: Callback
            });
        }
        static ShowExport(SchemaID, ViewID) {
            EntitiesList.CreateTemporaryView(function (Data) {
                Navigation.Redirect("/crm/export/?schemaid=" + SchemaID + "&viewid=" + Data.ViewID + "&originalviewid=" + ViewID);
            });
            return false;
        }
        static ShowImport(SchemaID, ViewID) {
            EntitiesList.CreateTemporaryView(function (Data) {
                Navigation.Redirect("/crm/import/?schemaid=" + SchemaID + "&viewid=" + Data.ViewID + "&originalviewid=" + ViewID)
            });
            return false;
        }
        static ColumnUpdate(SchemaID, ViewID, PropertyID) {
            EntitiesList.CreateTemporaryView(function (Data) {
                Navigation.Redirect("/crm/columnupdate/?schemaid=" + SchemaID + "&viewid=" + Data.ViewID + "&propertyid=" + PropertyID + "&originalviewid=" + ViewID);
            });
            return false;
        }
    }
}

$(document).on("OfficeGuy.AjaxLoaded", function (Event, $Container) {
    OfficeGuy.Common.InitEditors($Container);
    OfficeGuy.CRM.EntitiesList.InitTableRowClick($Container);

    $("form", $Container).each(function () {
        var $Form = $(this);
        if ($Form.closest('.modal').length == 0) {
            var $ContainerToRefresh = $Form.closest(".sumit-lightbox-container");
            if ($ContainerToRefresh.length == 0)
                $ContainerToRefresh = null;
            OfficeGuy.Forms.ConvertFormToAjax($Form, $ContainerToRefresh);
        }
    });
});
